import Image from 'components/ui/Image';
import Link from 'components/ui/Link';
import { useTranslation } from 'hooks/useTranslation';
import styles from './AuthorList.module.scss';
import type { IAuthorFields } from 'types/contentful/generated';

type Props = {
  entry: {
    authorList: { fields: IAuthorFields }[];
  };
};

const List = ({ entry }: Props): JSX.Element => {
  const { t, locale } = useTranslation();

  return (
    <ul>
      {entry.authorList.map((item) => {
        const { name, photo, slug } = item.fields;
        const authorLink = `/${locale}/${t('authors').toLowerCase()}/${slug}`;

        return (
          <li key={slug} className={styles.author}>
            <div className={styles.imageWrapper}>
              {photo && (
                <div>
                  <Link
                    href={authorLink}
                    target="_self"
                    className={styles.imageLink}
                    legacyBehavior={false}
                  >
                    <Image
                      src={photo.fields.file.url}
                      className={styles.image}
                      focus="face"
                      fit="thumb"
                      width={192}
                      height={192}
                      alt={name}
                    />
                  </Link>
                </div>
              )}
            </div>
            <div className={styles.content}>
              <h3 className={styles.name}>
                <Link
                  href={authorLink}
                  className={styles.nameLink}
                  target="_self"
                  legacyBehavior={false}
                >
                  {name}
                </Link>
              </h3>
              <p className={styles.description}>
                <Link
                  href={authorLink}
                  className={styles.descriptionLink}
                  target="_self"
                  legacyBehavior={false}
                >
                  {item.fields.description}
                </Link>
              </p>
              <div className={styles.readMore}>
                <Link
                  href={authorLink}
                  className={styles.readMoreLink}
                  target="_self"
                  legacyBehavior={false}
                >
                  {' '}
                  {t('blog.readMore')}
                </Link>
              </div>
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default List;
